$(function () {
    var isFlag = {};

    // Responsive
    isFlag.Tablet = window.matchMedia("(max-width: 1023px)").matches;
    isFlag.SP = window.matchMedia("(max-width: 767px)").matches;
    var heightHeader = $(".header__backfill").innerHeight();

    function handleAnchor() {
        $('a[href*="#"]')
            .not('[href="#"]')
            .click(function (event) {
                if ($(".js-menu").hasClass("is-open")) {
                    enableScroll();
                    $(".js-menu").removeClass("is-open");
                    $(".c-header__menuouter").removeClass("is-show");
                }

                if (location.pathname.replace(/^\/|\/$/g, "") == this.pathname.replace(/^\/|\/$/g, "") && location.hostname == this.hostname) {
                    event.preventDefault();

                    var section = $(this.hash);
                    if (section.length) {
                        $("html, body").animate(
                            {
                                scrollTop: section.offset().top - heightHeader,
                            },
                            1000
                        );
                    }
                } else {
                    window.location = this.href;
                }
            });

        var hash = window.location.hash;
        if (hash.length) {
            $("html, body").animate(
                {
                    scrollTop: $(hash).offset().top - heightHeader,
                },
                1000
            );
        }
    }

    function handleVideo() {
        if ($(".js-video").length) {
            $(".js-video").click(function () {
                if ($(this).hasClass("is-play")) {
                    $(this).removeClass("is-play");
                    $(this).find("video").trigger("pause");
                    $(this).find("video").prop("muted", true);
                } else {
                    $(this).addClass("is-play");
                    $(this).find("video").trigger("play");
                    $(this).find("video").prop("muted", false);
                }
            });
        }
    }

    function handleMainvisual() {
        if ($(".c-mv").length) {
            setTimeout(function () {
                $(".c-mv__suspense").removeClass("is-default").addClass("is-fade");
            }, 500);

            setTimeout(function () {
                $(".c-mv__suspense").removeClass("is-fade");
            }, 700);

            setTimeout(function () {
                $(".c-mv__title").removeClass("is-default");
            }, 1400);

            setTimeout(function () {
                $(".c-mv__thumb2").removeClass("is-hide");
            }, 2000);

            setTimeout(function () {
                $(".c-mv__thumb3").removeClass("is-hide");
            }, 2700);

            setTimeout(function () {
                $(".c-mv__packageinner, .c-mv__subtitle1, .c-mv__subtitle2, .c-mv__subtitle3, .c-mv__subtitle4, .c-fixedbtn1").removeClass("is-default");
            }, 3100);
        }
    }

    function handleReveal(scope) {
        var searchRoot = scope || document;
        var root = null;

        if (searchRoot.nodeType === 1 && searchRoot.matches && searchRoot.matches(".rakuatsu-lp")) {
            root = searchRoot;
        } else if (searchRoot.querySelector) {
            root = searchRoot.querySelector(".rakuatsu-lp");
        }

        if (!root || root.dataset.revealInitialized === "true") return;

        var targets = root.querySelectorAll(".reveal");
        if (!targets.length) return;

        root.dataset.revealInitialized = "true";

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
            targets.forEach(function (target) {
                target.classList.add("is-visible");
            });
            return;
        }

        root.classList.add("is-reveal-ready");

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;

                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                });
            },
            {
                threshold: 0.15,
                rootMargin: "0px 0px -12% 0px",
            }
        );

        targets.forEach(function (target) {
            observer.observe(target);
        });
    }

    function run() {
        handleAnchor();
        handleVideo();
        handleMainvisual();
        handleReveal();
    }

    run();

    document.addEventListener("shopify:section:load", function (event) {
        handleReveal(event.target);
    });
});